<template>
    <div class="relative flex items-center justify-center">
        <svg
            viewBox="0 0 100 100"
            :height="height ? height : '100%'"
            :width="width ? width : '100%'"
        >
            <circle
                cx="50"
                cy="50"
                :r="radius"
                stroke="currentColor"
                :stroke-width="ringWidth"
                fill="transparent"
                class="text-gray-325"
                transform="rotate(-90, 50, 50)"
            />

            <circle
                cx="50"
                cy="50"
                :r="radius"
                stroke="currentColor"
                :stroke-width="ringWidth"
                fill="transparent"
                :stroke-dasharray="strokeDasharrayVal"
                :class="progressColor"
                transform="rotate(-90, 50, 50)"
            />
        </svg>
        <div
            class="item-center absolute flex flex-col justify-center gap-0 text-center font-semibold"
        >
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    name: "NewProgressRing",
    props: {
        height: {
            type: String,
            default: null,
        },
        width: {
            type: String,
            default: null,
        },
        ringWidth: {
            type: Number,
            default: 11,
        },
        colors: {
            type: Object,
            default: [
                { stop: 90, css: "text-green-500" },
                { stop: 71, css: "text-yellow-500" },
                { stop: 0, css: "text-red-500" },
            ],
        },
        radius: {
            type: Number,
            default: 44,
        },
        percentFilled: {},
    },
    data() {
        return {};
    },
    computed: {
        strokeDasharrayVal() {
            let circleLength = 2 * Math.PI * this.radius;
            let dashLength = this.percentFilled * (circleLength / 100);

            return dashLength + " " + circleLength;
        },
        progressColor() {
            let vm = this;
            let progressColor = "text-gray-325";

            this.colors.every(function (color) {
                if (vm.percentFilled >= color.stop) {
                    progressColor = color.css;
                    return false;
                } else {
                    return true;
                }
            });

            return progressColor;
        },
    },
};
</script>
